import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const accommodationAgeGroupedTotalCapacityEntity: Entity = {
  model: model,
  repository: repository,
}

export default accommodationAgeGroupedTotalCapacityEntity
